/** Отображаемое имя бренда (шапка, мета, OG и т.д.) */
export const SITE_BRAND = 'Марина Камбур';
